import CampaignZoom from "../CampaignZoom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { campaignAscensis } from "../../Utils/CampaignDefinitions";

const Ascensis = () => {
  const [fullScreenPicture, setFullScreenPicture] = useState<
    string | undefined
  >(undefined);
  const picList = [
    "/ascensis/ascensis1.jpg",
    "/ascensis/Ascensis2.jpg",
    "/ascensis/Ascensis3.jpg",
    "/ascensis/Ascensis4.jpg",
    "/ascensis/Ascensis5.jpg",
    "/ascensis/Ascensis6.jpg",
    "/ascensis/Ascensis7.jpg",
    "/ascensis/Ascensis8.jpg",
    "/ascensis/Ascensis9.jpg",
    "/ascensis/Ascensis10.jpg",
    "/ascensis/Ascensis11.jpg",
    "/ascensis/Ascensis12.jpg",
    "/ascensis/Ascensis13.jpg",
    "/ascensis/Ascensis14.jpg",
  ];

  const [scrollPosition, setScrollPosition] = useState<number>(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScroll = () => {
    window.scrollTo(0, scrollPosition);
  };

  const renderVerticalRange = (range: string[]) => (
    <div className="campaignPicRange pointer">
      {range.map((picture, key) => (
        <img
          key={key}
          aria-label="Campaign Ascensis squillace 1923 leather gloves"
          className="campaignPicVerticalKatabasis"
          src={`/ascensis/${picture}`}
          alt={`campaign ${campaignAscensis.title} squillace1923 gloves`}
          onClick={() => {
            setScrollPosition(window.pageYOffset);
            setFullScreenPicture(`/ascensis/${picture}`);
          }}
        />
      ))}
    </div>
  );

  const renderHorizontalRange = (range: string) => (
    <div className="campaignPicRange">
      <img
        key={3}
        aria-label="Campaign Ascensis squillace 1923 leather gloves"
        className="campaignPicHorizontal pointer"
        src={`/ascensis/${range}`}
        alt={`campaign ${campaignAscensis.title} squillace1923 gloves`}
        onClick={() => {
          setScrollPosition(window.pageYOffset);
          setFullScreenPicture(`/ascensis/${range}`);
        }}
      />
    </div>
  );
  const ranges = campaignAscensis.pictureRanges;

  return (
    <div className="content">
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta>
        <title>
          Squillace 1923 - Luxury leather gloves campaign handmade in Italy -
          Ascensis season 23
        </title>

        <meta
          name="description"
          content="Squillace 1923 is the Haute Couture brand by Omega srl. 
    Luxurious and elegant leather gloves collections, made in Naples following the ancestral phases of production, entirely handmade."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="title">
        <h1>{campaignAscensis.title.toUpperCase()}</h1>
        <h2>
          {campaignAscensis.description.map((text, index) => (
            <>
              {text}
              <br></br>
              <br></br>
            </>
          ))}
        </h2>
      </div>
      <div className="campaignPic">
        {renderHorizontalRange(ranges.firstRange)}
        {renderVerticalRange(ranges.secondRange)}
        {renderVerticalRange(ranges.thirdRange)}
        {renderVerticalRange(ranges.fourthRange)}
        {renderVerticalRange(ranges.fifthRange)}
        {renderVerticalRange(ranges.sixthRange)}
        {renderVerticalRange(ranges.seventhRange)}
      </div>

      {fullScreenPicture && (
        <CampaignZoom
          picList={picList}
          fullScreenPicture={fullScreenPicture}
          setFullScreenPicture={setFullScreenPicture}
          handleScroll={handleScroll}
        />
      )}
    </div>
  );
};

export default Ascensis;
